// StepPropertyStatus.jsx — FINAL (balanced)

import { useState } from "react";
import { Home, Sparkles } from "lucide-react";

const options = [
  {
    key: "airbnb",
    title: "Already listed on Airbnb",
    desc: "Analyse pricing, occupancy and performance instantly",
    icon: Home,
  },
  {
    key: "new",
    title: "Not listed yet",
    desc: "Get revenue estimate and setup strategy",
    icon: Sparkles,
    recommended: true,
  },
];

export default function StepPropertyStatus({ onSelect }) {
  const [selected, setSelected] = useState(null);

  function handleSelect(key) {
    setSelected(key);
    onSelect?.(key); // ⚡ instant
  }

  return (
    <div className="max-w-content space-y-6">

      {/* HEADER */}
      <div>
        <h2 className="text-title font-extrabold text-text-primary leading-tight">
          Is your property already listed?
        </h2>

        <p className="mt-2 text-body text-text-muted">
          We’ll tailor your analysis instantly.
        </p>
      </div>

      {/* OPTIONS */}
      <div className="grid gap-3">

        {options.map((o) => {
          const Icon = o.icon;
          const isActive = selected === o.key;

          return (
            <button
              key={o.key}
              onClick={() => handleSelect(o.key)}
              className={`
                relative w-full text-left
                rounded-[22px] border
                px-4 py-4 md:px-5 md:py-5
                transition-all duration-200

                ${
                  isActive
                    ? "border-accent-gold bg-brand-secondary shadow-card"
                    : o.recommended
                      ? "border-brand-primary bg-bg-surface"
                      : "border-border-soft bg-bg-surface hover:border-accent-gold/40 hover:-translate-y-[1px]"
                }
              `}
            >

              {/* 🔥 RECOMMENDED TAG */}
              {o.recommended && !selected && (
                <div className="
                  absolute top-3 right-3
                  rounded-pill px-2.5 py-1
                  text-[10px] font-semibold tracking-[0.12em]
                  border border-accent-gold/30
                  bg-accent-gold/10 text-accent-gold
                ">
                  RECOMMENDED
                </div>
              )}

              <div className="flex items-start gap-3">

                {/* ICON */}
                <div
                  className={`
                    flex h-10 w-10 items-center justify-center rounded-xl border
                    ${
                      isActive
                        ? "bg-accent-gold text-black border-accent-gold"
                        : o.recommended
                          ? "border-brand-primary bg-brand-light text-accent-gold"
                          : "border-border-soft bg-bg-light text-text-muted"
                    }
                  `}
                >
                  <Icon size={18} />
                </div>

                {/* TEXT */}
                <div className="flex-1">
                  <div className="text-[15px] font-semibold text-text-primary">
                    {o.title}
                  </div>

                  <div className="text-small text-text-muted mt-1">
                    {o.desc}
                  </div>
                </div>

              </div>

              {/* ACTIVE OUTLINE (lightweight) */}
              {isActive && (
                <div className="pointer-events-none absolute inset-0 rounded-[22px] border border-accent-gold/60" />
              )}

            </button>
          );
        })}

      </div>

      {/* FOOT */}
      <p className="text-micro text-text-muted">
        Takes less than 30 seconds
      </p>

    </div>
  );
}